import { Box, Stack, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import AddDispositivo from './AddDispositivo';
import { useDevicesQuery, useUsersQuery } from '../../../hooks/queries.js';
import TablaDispositivos from './TablaDispositivos.jsx';
import useCheckToken from '../../../hooks/useCheckToken.js';
import { useAppStore } from '../../../store/appStore.tsx';


const Dispositivos = () => {
    //useCheckToken();

    const currentUser = useAppStore(appStore => appStore.currentUser);
    //console.log("currentUser: ", currentUser);

    useEffect(() => {
        // Prompt confirmation when reload page is triggered
        window.onbeforeunload = () => { return "" };
        // Unmount the window.onbeforeunload event
        return () => { window.onbeforeunload = null };
    }, []);

    const devIdStr = currentUser.devIdStr;
    // Parsear el string a un array de objetos de JavaScript
    const dispositivos = JSON.parse(devIdStr);

    // Extraer únicamente los devId usando map()
    const devIds = dispositivos.map(dispositivo => dispositivo.devId);
    //console.log("devIds:", devIds);

    /* Recuperación de todos los usuarios en la base de datos */
    const bodyUsers = { comando: "CMD_GET_USERS" };
    const usersQuery = useUsersQuery(bodyUsers);

    /* Recuperación de los dispositivos en la base de datos */
    const bodyDev = { comando: "CMD_GET_DISPOSITIVOS", data: { devIds } };   //body es un objeto con: {comando, token, data}
    const devQuery = useDevicesQuery(bodyDev);

    /* Mientras no se reciban los datos de todas las consulta, muestra el estado */
    if (
        usersQuery.isPending ||
        devQuery.isPending ||
        usersQuery.isError ||
        devQuery.isError
    ) return (
        <Box paddingTop={3}>
            {usersQuery.isPending ? <p>Cargando Usuarios...</p> : ''}
            {devQuery.isPending ? <p>Cargando Dispositivos...</p> : ''}
            {usersQuery.isError ? <p>Error Cargando Usuarios:  {usersQuery.error.message}</p> : ''}
            {devQuery.isError ? <p>Error Cargando Dispositivos: {devQuery.error.message}</p> : ''}
        </Box>
    );

    /* Si todas las consultas han dado resultado correcto, entonces se asignan variables con los datos recibidos */
    const users = usersQuery.data.result.rows;
    const devices = devQuery.data.result.rows;
    //console.log(usersQuery.data);
    //console.log(devQuery.data);

    return (
        <Stack
            direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
            spacing={0}
            justifyContent={{ lg: 'center' }}
            flexGrow={1} pt={2} pb={2}
        >
            {(currentUser.tipoUsuario === 'superusuario' || currentUser.tipoUsuario === 'administrador') && (
                <Box bgcolor='white' flex={3} padding={2} style={{ borderRadius: 0, width: '100%' }}>
                    <Typography variant="h5" component="h5" p={2} align='center'>
                        Detalle del dispositivo seleccionado
                    </Typography>
                    <AddDispositivo

                    />
                </Box>
            )}
            <Box bgcolor='white' borderLeft={1} borderColor='lightgray' flex={9} marginRight={0} padding={2} style={{ width: '100%', borderRadius: 0 }} >

                <TablaDispositivos
                    currentUser={currentUser}
                    dispositivos={devices}
                    usuarios={users}
                    titulo="dispositivos"
                />

            </Box>
        </Stack>
    )
}

export default Dispositivos